<div class="code-box_title">
    <h4>{{ 'SETTING_PAGE.INFORMATE_SETTINGS.CALCULATION_PREFERENCES_TAB.CALCULATION_RESULTS' | transloco }} </h4>
</div>
<div class="card-body">



    <div [formGroup]="form" class="calc-results-cont">
        <div class="example-section" *ngFor="let value of resultOptions">
            <mat-checkbox [calc-result-check] class="example-margin checkbox-wrap" name="resultOptionEl"
                [checked]="setCheckedValue(value)" (change)="setFieldValue(value, $event)">{{ value }}</mat-checkbox>
        </div>

        <input type="hidden" [formControlName]="setFieldKey()" value="resultOptionsChecked" />
    </div>
</div>